<template>
    <el-dialog
        :title="isForm ? (upgradeDetail?.id ? '编辑' + dialogTitle : '添加升级文件') : '查看' + dialogTitle"
        :model-value="modelValue"
        width="650px"
        top="8vh"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            :rules="isForm ? formRules : {}"
            :validate-on-rule-change="false"
            v-loading="formLoading"
            label-width="120px"
            style="max-width: 800px"
        >
            <el-row>
                <el-col :span="24">
                    <el-form-item label="文件名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入文件名称"></el-input>
                        <div v-else>{{ formData.name }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-col :span="24">
                <el-form-item label="版本号" prop="version">
                    <el-input v-if="isForm" v-model="formData.version" placeholder="请输入版本号"></el-input>
                    <div v-else>{{ formData.version }}</div>
                </el-form-item>
            </el-col>
            <el-form-item label="升级文件" prop="upgrade_file">
                <div style="width: 100%">
                    <el-upload
                        v-if="isForm"
                        ref="manualUploader"
                        class="uploader"
                        action="#"
                        :limit="1"
                        :auto-upload="false"
                        :on-exceed="handleFileExceed"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :file-list="filesEditLists"
                        accept=".bin"
                    >
                        <el-button type="primary" :icon="UploadFilled">请选择文件...</el-button>
                        <template #tip>
                            <div class="el-upload__tip">请上传 升级文件 最多上传1个.</div>
                        </template>
                    </el-upload>
                    <div v-else>
                        <!-- 文件 / 其他 -->
                        {{ formData.downloadUrl }}
                        <a v-if="formData.upgrade_file" :href="formData.downloadUrl" target="_blank">
                            <el-button type="primary" :icon="Download">查看</el-button>
                        </a>
                        <span v-else>-</span>
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确认</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineProps, defineEmits, ref, onMounted } from 'vue'
import { UploadFilled, Download } from '@element-plus/icons'
import { addUpgradeFileApi, putUpgradeFileApi } from '@/api/thermostat/devicePoint.js'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    upgradeDetail: {
        type: Object,
        required: false
    }
})

const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    id: '',
    name: '',
    version: '',
    upgrade_file: ''
})
// 验证规则
const formRules = ref({
    name: [{ required: true, trigger: 'blur', message: '文件名称为必填项' }],
    version: [{ required: true, trigger: 'blur', message: ' 版本号为必填项' }],
    upgrade_file: [
        {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
                if (postAttach.value) {
                    callback()
                } else {
                    return callback(new Error('请选择上传文件'))
                }
            }
        }
    ]
})
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}
// 提交data数据修饰
const getPostFormData = () => {
    console.log(formData.value)
    const postFormData = new FormData()
    if (formData.value.id) {
        postFormData.append('id', formData.value.id)
    }
    postFormData.append('name', formData.value.name ? formData.value.name : '')
    postFormData.append('version', formData.value.version ? formData.value.version : '')
    if (postAttach.value) {
        postFormData.append('upgrade_file', postAttach.value)
    }

    return postFormData
}
// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    const postData = getPostFormData()
    if (formData.value.id) {
        await doPutExamLibCourseware(postData)
    } else {
        await doAddExamLibCourseware(postData)
    }
}
// 添加
const doAddExamLibCourseware = async (postData) => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addUpgradeFileApi(postData)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('添加成功')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}
// 修改
const doPutExamLibCourseware = async (postData) => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await putUpgradeFileApi(postData)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('操作成功')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

const dialogTitle = ref('')
const filesEditLists = ref([])
const postAttach = ref('')
const formLoading = ref(false)
// 获取品牌详情
const doGetCoursewareDetail = async () => {
    console.log(props.upgradeDetail)
    dialogTitle.value = props.upgradeDetail.name
    formData.value = {
        id: props.upgradeDetail.id,
        name: props.upgradeDetail.name,
        version: props.upgradeDetail.version,
        upgrade_file: props.upgradeDetail.path
    }

    if (formData.value.upgrade_file) {
        filesEditLists.value = [{ name: props.upgradeDetail.path, url: props.upgradeDetail.path }]
    }
    postAttach.value = props.upgradeDetail.path
    formLoading.value = false
}
// 文件选择超出限制
const manualUploader = ref()
const handleFileExceed = (files) => {
    ElMessage.warning('超限啦，只允许上传一个课件！')
}

// handleFileChange
const handleFileChange = (file, fileList) => {
    postAttach.value = file.raw
}
// handleFileRemove
const handleFileRemove = (file, fileList) => {
    postAttach.value = ''
}

// 只有macId有的时候，才会去请求数据
onMounted(async () => {
    formLoading.value = true
    // 置空
    formData.value = {
        id: '',
        name: '',
        version: '',
        upgrade_file: ''
    }
    postAttach.value = ''
    filesEditLists.value = []
    formLoading.value = false
    if (props.upgradeDetail) {
        doGetCoursewareDetail()
    }
})
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 0;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
</style>
